import { FC, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';

type Props = {
    id: string;
    height: number | null;
    buffer?: number;
    triggerDummyRender?: boolean;
};

//hook used to fill the height of element to fit the screen
export const useFillHeightToFitScreen = ({ id, height, buffer = 0, triggerDummyRender = false }: Props) => {
    const [triggerRender, setTriggerRender] = useState(0);
    const tempHeight = useRef(height);

    function calculateRemainingHeight() {
        const element = document.getElementById(id);
        if (element) {
            const elementTopPosition = element?.getBoundingClientRect()?.top;
            const windowHeight = window.innerHeight;
            const remainingHeight = windowHeight - elementTopPosition - buffer;
            return remainingHeight;
        }
        return null;
    }
    useEffect(() => {
        //this is used to avoid re-computing of height during each re-rendering once its computed once
        if (!height) {
            const calculatedHeight = calculateRemainingHeight();
            if (triggerDummyRender) {
                setTriggerRender((prev) => prev + 1);
            }
            tempHeight.current = calculatedHeight;
        } else {
            tempHeight.current = height;
        }
    }, [height]);

    return tempHeight.current;
};

type IProps = {
    id: string;
    percentageNumber: number;
    width: number | null;
    buffer?: number;
    triggerDummyRender?: boolean;
};
export const useConvertPercentageToPxWidth = ({
    id,
    percentageNumber,
    width,
    buffer = 0,
    triggerDummyRender = false,
}: IProps) => {
    const [triggerRender, setTriggerRender] = useState(0);
    const tempWidth = useRef(width);

    function calculateWidth() {
        const element = document.getElementById(id);
        if (element) {
            const elementWidth = element?.getBoundingClientRect()?.width;
            const elementPercentageWidth = (elementWidth * percentageNumber) / 100;
            return elementPercentageWidth;
        }
        return null;
    }

    //dont change from use memo to another hook as usememo runs during render phase
    useMemo(() => {
        //this is used to avoid re-computing of height during each re-rendering once its computed once
        if (!width) {
            const calculatedWidth = calculateWidth();
            if (triggerDummyRender) {
                setTriggerRender((prev) => prev + 1);
            }
            tempWidth.current = calculatedWidth;
        } else {
            tempWidth.current = width;
        }
    }, [width]);
    // useEffect(() => {
    //     //this is used to avoid re-computing of height during each re-rendering once its computed once
    //     if (!width) {
    //         const calculatedHeight = calculateRemainingHeight();
    //         if (triggerDummyRender) {
    //             setTriggerRender((prev) => prev + 1);
    //         }
    //         tempWidth.current = calculatedHeight;
    //     } else {
    //         tempWidth.current = width;
    //     }
    // }, [width]);

    return tempWidth.current;
};
